import "./scss/main.scss";

import jQuery from "jquery";
import './js/cookie.js';
import {webSocket} from './js/chat.js';
window.$ = window.jQuery = jQuery;

$("#submit").on("click", function () {
  $("#" + $(this).data("icon")).removeClass("fa-arrow-right text-muted").addClass("fa-sync fa-spin");
});

$("#frm-signInForm").on("focusin", function () {
  $("#login").removeClass("process");
  $("#login").attr("disabled", false);
});

$("#frm-signInForm").on("submit", function () {
  $("#login").addClass("process");
  $("#login").attr("disabled", true);
});

console.log("login");